import React from 'react';
import PropTypes from 'prop-types';
import FontAwesome from 'react-fontawesome';
import { _AddItemsButton } from "./styles";
var AddHideNote = function AddHideNote(_ref) {
  var _ref$addingNote = _ref.addingNote,
    addingNote = _ref$addingNote === void 0 ? false : _ref$addingNote,
    onAddNote = _ref.onAddNote,
    onCollapseNote = _ref.onCollapseNote;
  return /*#__PURE__*/React.createElement(React.Fragment, null, addingNote ? /*#__PURE__*/React.createElement(_AddItemsButton, {
    onClick: onCollapseNote
  }, "Hide ", /*#__PURE__*/React.createElement(FontAwesome, {
    name: "minus"
  })) : /*#__PURE__*/React.createElement(_AddItemsButton, {
    onClick: onAddNote
  }, "Add Note ", /*#__PURE__*/React.createElement(FontAwesome, {
    name: "plus"
  })));
};
AddHideNote.propTypes = {
  addingNote: PropTypes.bool.isRequired,
  onAddNote: PropTypes.func.isRequired,
  onCollapseNote: PropTypes.func.isRequired
};
export default AddHideNote;